import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Fluid Gallery",
    description: "A photographic practice working with prisms, long exposures and one west-facing window. Twelve plates, on one liquid canvas.",
    url: getOrigin()
}
